import { priceData } from "./data"
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { StyledSelect } from "./style"
import { useEffect, useState } from "react"
import DialogBox from "./Dialog"
import { motion } from 'framer-motion'
import { Helmet } from "react-helmet"


const Pricing = () => {

  const [staffq1, setstaffq1] = useState('')
  const [staffq2, setstaffq2] = useState('')
  const [productq1, setproductq1] = useState('')
  const [productq2, setproductq2] = useState('')
  const [teamq1, setteamq1] = useState('')
  const [teamq2, setteamq2] = useState('')
  const [img, setimg] = useState('')


  const [ans1, setans1] = useState('')
  const [ans2, setans2] = useState('')
  const [title, settitle] = useState('')

  const [open, setopen] = useState(false)

  const currentValue = (num) => {
    if (num === 0) {
      return staffq1
    }
    else if (num === 1) {
      return productq1
    }
    else if (num === 2) {
      return teamq1
    }
  }
  const currentValue2 = (num) => {
    if (num === 0) {
      return staffq2
    }
    else if (num === 1) {
      return productq2
    }
    else if (num === 2) {
      return teamq2
    }
  }

  const handleChange = (e, num) => {
    if (num === 0) {
      setstaffq1(e.target.value)
    }
    else if (num === 1) {
      setproductq1(e.target.value)
    }
    else if (num === 2) {
      setteamq1(e.target.value)
    }
  }
  const handleChange2 = (e, num) => {
    if (num === 0) {
      setstaffq2(e.target.value)
    }
    else if (num === 1) {
      setproductq2(e.target.value)
    }
    else if (num === 2) {
      setteamq2(e.target.value)
    }
  }

  const handleClick = (e, item) => {

    settitle(item.title)
    setimg(item.img)
    e.preventDefault()

    if (item.title === 'Staff/Resource Augmentation') {
      setans1(staffq1)
      setans2(staffq2)
    }
    else if (item.title === 'Product Development') {
      setans1(productq1)
      setans2(productq2)

    }
    else if (item.title === 'Dedicated Team') {
      setans1(teamq1)
      setans2(teamq2)

    }
    setopen(true)
  }


  useEffect(() => {

    window.scrollTo(0, 0)

  }, [])

  return (


    <div className="bg-gray-50 dark:bg-gray-900 transition-all duration-700">

      <Helmet >
        <title>CodeZone | Pricing</title>
      </Helmet>

      <div className='main-class max-w-screen-2xl w-[90%] mx-auto md:w-full pt-[70px]'>
        <h1 className=' text-2xl md:text-3xl text-center font-bold my-7 dark:text-white'>Our <span className='text-red-500'>Pricing</span></h1>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pb-6'>
          {priceData.map((item, i) => {

            return <motion.div
              whileInView={{ scale: [0.8, 1] }}
              transition={{ duration: 0.8, ease: 'easeInOut' }}
              key={i}
            >
              <div className={` duration-700 rounded-t-lg shadow-md md:hover:scale-105 bg-white  rounded-b-md border-b-8 ${i === 0 ? 'border-red-500' : i === 1 ? 'border-gray-800 dark:border-gray-700' : 'border-yellow-600'}`}>

                <div className={`${item.color} p-3 rounded-t-lg flex flex-col items-center`}>
                  <img src={item.img} alt="img" className="h-[30px]" />
                  <h1 className="text-white mt-2 font-bold text-base text-center">{item.title}</h1>
                  <p className="text-center text-white text-xs">{item.desc}</p>
                </div>

                <div className="m-3 mb-0 border-b-2 pb-5 border-slate-200">
                  <h1 className="text-center font-bold text-base">{item.title}</h1>
                  <div className="space-y-3 mt-3">
                    {item.points.map((value, index) => (
                      <div key={index} className='flex gap-2 items-center'>
                        <div>
                          <CheckCircleIcon className={`h-[25px]  ${i === 0 ? 'text-red-500' : i === 1 ? 'text-gray-800' : 'text-yellow-600'}`} />
                        </div>
                        <p className="text-xs">{value}</p>
                      </div>
                    ))}
                  </div>
                </div>
                <form className="p-3" onSubmit={(e) => handleClick(e, item)}>
                  <h1 className="text-sm font-bold">{item.Q1}</h1>
                  <StyledSelect>
                    <FormControl focused={false} sx={{ width: { xs: '100%', md: '300px' }, borderRadius: '20px !important' }}>
                      <InputLabel id="demo-simple-select-label">Choose</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        required
                        name='Status'
                        value={currentValue(i)}
                        label="Status"
                        onChange={(e) => handleChange(e, i)}
                        InputProps={{
                          disableUnderline: true,
                          style: {
                            borderRadius: '20px'
                          }
                        }}
                        MenuProps={{ disableScrollLock: true }}
                      >
                        {item.ans1.map((value, i) => (
                          <MenuItem value={value} key={i}>{value}</MenuItem>
                        ))}

                      </Select>
                    </FormControl>
                  </StyledSelect>

                  <h1 className="text-sm font-bold mt-3">{item.Q2}</h1>
                  <StyledSelect>
                    <FormControl focused={false} sx={{ width: { xs: '100%', md: '300px' }, borderRadius: '20px !important' }}>
                      <InputLabel id="demo-simple-select-label">Choose</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        required
                        name='Status'
                        value={currentValue2(i)}
                        label="Status"
                        onChange={(e) => handleChange2(e, i)}
                        InputProps={{
                          disableUnderline: true,
                          style: {
                            borderRadius: '20px'
                          }
                        }}
                        MenuProps={{ disableScrollLock: true }}
                      >
                        {item.ans2.map((value, i) => (
                          <MenuItem value={value} key={i}>{value}</MenuItem>
                        ))}

                      </Select>
                    </FormControl>
                  </StyledSelect>

                  <div className='pt-6 pb-1'>

                    <button
                      type='submit'
                      className={`w-full rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[14px] md:text-[17px]   ${i === 0 ? 'border-red-500' : i === 1 ? 'border-gray-800' : 'border-yellow-600'}`}>
                      <span className={`absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease ${i === 0 ? 'bg-red-500' : i === 1 ? 'bg-gray-800' : 'bg-yellow-600'}`}></span>
                      <span className={`relative ${i === 0 ? 'text-red-500' : i === 1 ? 'text-gray-800' : 'text-yellow-600'} transition duration-700 ease group-hover:text-white`}>Get A Free Quote</span>
                    </button>
                  </div>
                </form>
              </div>
            </motion.div>
          })}
        </div>
      </div>
      <DialogBox open={open} setOpen={setopen} img={img} title={title} ans1={ans1} ans2={ans2} />
    </div >
  )
}

export default Pricing